import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { getRecaptchaToken } from "@/lib/recaptcha";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const recaptcha_token = await getRecaptchaToken("newsletter");
      await api.post("/newsletter/subscribe", { email, recaptcha_token });
      toast.success("You're in. Welcome to ITTV News.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-[color:var(--text)] text-[color:var(--bg)] py-16" data-testid="newsletter-section">
      <div className="container-editorial grid md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="kicker text-[color:var(--accent)] mb-3">The ITTV Weekly Dispatch</div>
          <h2 className="font-serif text-4xl md:text-6xl font-bold leading-none tracking-tight">
            Journalism that respects your time and attention.
          </h2>
          <p className="mt-6 text-lg opacity-70 max-w-lg">
            One well-argued long read, three sharp shorter pieces, no clickbait. Every Sunday morning, in your inbox.
          </p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="newsletter-form">
          <label className="kicker opacity-70 block">Email address</label>
          <div className="flex flex-col sm:flex-row border" style={{ borderColor: "rgba(255,255,255,0.3)" }}>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="flex-1 bg-transparent px-4 py-4 outline-none placeholder:opacity-40 text-lg"
              data-testid="newsletter-email-input"
            />
            <button type="submit" disabled={busy} className="btn-accent disabled:opacity-50" data-testid="newsletter-submit">
              {busy ? "Subscribing..." : "Subscribe"}
            </button>
          </div>
          <p className="text-xs opacity-50">Protected by reCAPTCHA. No spam. Unsubscribe anytime.</p>
        </form>
      </div>
    </section>
  );
}
